import { useCallback, useState } from 'react';
import { BrandLockup } from './components/BrandLockup.js';
import { PairingScreen } from './screens/PairingScreen.js';
import { PlaybackStage } from './screens/PlaybackStage.js';
import { WaitingForContentScreen } from './screens/WaitingForContentScreen.js';
import { useKioskSession } from './hooks/useKioskSession.js';

export function App() {
  const session = useKioskSession();
  const playing = session.phase === 'playing';
  const [hasMedia, setHasMedia] = useState(false);
  const onHasMediaChange = useCallback((next: boolean) => setHasMedia(next), []);

  return (
    <div
      ref={session.shellRef}
      className={playing ? 'kiosk kiosk--playing' : 'kiosk'}
      data-phase={session.phase}
    >
      <PlaybackStage
        stageRef={session.stageRef}
        active={playing}
        onHasMediaChange={onHasMediaChange}
      />

      {session.phase === 'booting' ? (
        <div className="boot-screen" role="status">
          <BrandLockup className="boot-screen__brand" />
          <p className="boot-screen__status">Starting player…</p>
        </div>
      ) : null}

      {session.phase === 'pairing' ? (
        <PairingScreen
          sessionCode={session.sessionCode}
          sessionExpiresAt={session.sessionExpiresAt}
          sessionError={session.sessionError}
          deviceCode={session.deviceCode}
          confirming={session.confirming}
          connected={session.connected}
          connectedScreenName={session.connectedScreenName}
          busy={session.pairing}
          error={session.error}
          onSubmit={session.submitPairing}
          onClearError={session.clearError}
          onRefreshSession={session.refreshPairingSession}
        />
      ) : null}

      <WaitingForContentScreen
        visible={playing && !hasMedia}
        idleDisplay={session.idleDisplay}
      />
    </div>
  );
}
